import type { JSX, SVGProps } from "react";

export function CaretDown({ height = 6, width = 13, fill, ...rest }: SVGProps<SVGSVGElement>): JSX.Element {
    return (
        <svg width={width} height={height} viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.91107 0.91107C1.23651 0.585633 1.76414 0.585633 2.08958 0.91107L6.50032 5.32181L10.9111 0.91107C11.2365 0.585633 11.7641 0.585633 12.0896 0.91107C12.415 1.23651 12.415 1.76414 12.0896 2.08958L7.08958 7.08958C6.76414 7.41502 6.23651 7.41502 5.91107 7.08958L0.91107 2.08958C0.585633 1.76414 0.585633 1.23651 0.91107 0.91107Z"
                fill={fill ?? "var(--mantine-color-dark-0)"}
            />
        </svg>
    );
}
